export default __webpack_public_path__ + "4cba833bc1c2200f3c137c6b41d6632c.svg";